import { Box, Theme } from "@mui/material";
import { formatNum } from "src/lib/number.helpers";

import { getStyles } from "./utils/styles";
import { getUnicodeSymbol } from "../Dashboard/helpers/dashboardChart.helper";
import { ChartTooltipFormatterParams } from "../Dashboard/interfaces/DashboardComponentParams";

export function TooltipUnicodeRow({
  param,
  firstValue,
  secondValue,
  thirdValue,
  forthValue,
  theme,
}: {
  param: ChartTooltipFormatterParams;
  firstValue?: number;
  secondValue: string;
  thirdValue?: number | string;
  forthValue?: string;
  theme: Theme;
}) {
  const styles = getStyles(theme);

  return (
    <Box style={styles.popupRow3Cols}>
      <Box style={styles.popupCol}>
        <Box style={styles.textPrimary}>{param.seriesName}</Box>
      </Box>

      <Box style={styles.popupColRight}>
        <Box style={styles.weather}>{getUnicodeSymbol(secondValue)}</Box>
        <Box style={styles.textPrimaryBold}>{firstValue !== undefined ? `${formatNum(firstValue)}°C` : ""}</Box>
      </Box>

      <Box style={styles.popupColLeft}>
        <Box style={styles.weather}>{getUnicodeSymbol(forthValue ?? "")}</Box>
        <Box>{thirdValue !== undefined && thirdValue !== "NA" ? `${formatNum(Number(thirdValue))}°C` : ""}</Box>
      </Box>
    </Box>
  );
}
